import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {TablesWidgetSenderApproval} from '../../../_metronic/partials/widgets/_new/tables/TablesWidgetSenderApproval'

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SenderApproval: FC = () => (
  <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
    <div className='col-lg-12'>
      <TablesWidgetSenderApproval className='card-xxl-stretch mb-5 mb-xl-10' />
    </div>
  </div>
)

const SenderApprovalWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>{intl.formatMessage({ id: 'PAGE.SENDER_APPROVAL', defaultMessage: 'Sender Approval' })}</PageTitle>
      <SenderApproval />
    </>
  )
}

export {SenderApprovalWrapper}
